import { Col, Typography } from "antd";
import styles from "assets/scss/jobAndClientBillingRules.module.scss";

const { Title, Paragraph } = Typography;

export const CommissionDetailItem = ({ title, value }) => {
  return (
    <Col xs={24} sm={12} md={8}>
      <Title level={5} className={styles.cbrLabel}>
        {title}
      </Title>
      <Paragraph className={styles.cbrValue}>{value}</Paragraph>
    </Col>
  );
};
